import * as popUpStyles from '../../../styles/layout/search-pop-up.module.scss';
import * as smartphoneStyles from '../../../styles/layout/smartphone-menu-nojs.module.scss';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {
  displayAriaLabelLanguages,
  displayLanguages,
  getFilteredAlgoliaResults,
  handleLanguageSelection,
} from '../../../utils/parsing';
import {getUserInfo, getUserInfoWithoutLogin, userLogout,} from '../../../services/auth';
import AppButton from '../../shared/AppButton';
import IconContainer from '../../shared/IconContainer';
import Image from '../../shared/Image';
import {Link} from 'gatsby';
import NavigationSmartphoneHtml from './NavigationSmartphoneHtml';
import Title from '../../shared/Title';
import algoliasearch from 'algoliasearch';
import {useTranslation} from 'react-i18next';
import AlgoliaResults from '../../../algolia/AlgoliaResults';

const ENABLE_JE_SUIS_MENU = false;
const ENABLE_ACCESS_COMPTE = false;

const Menu = React.memo(function Menu ({
  logoPartner,
  logo,
  name,
  locale,
  localizations,
  menu,
  communityMenu,
  corporateMenu,
  siteURL,
}) {
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openSearch, setOpenSearch] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const [buttonWidth, setButtonWidth] = React.useState(0);

  const [role, setRole] = React.useState('Étudiant');
  const [displayButton, setDisplayButton] = React.useState(false);
  const [userName, setUserName] = React.useState('');

  const [searchWord, setSearchWord] = React.useState('');
  const [results, setResults] = React.useState([]);

  const client = useMemo(() =>
    algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY), []);
  const index = useMemo(() =>
    client.initIndex(process.env.GATSBY_ALGOLIA_INDEX_NAME), [client]);

  const otherLanguage = localizations?.length > 0 ? localizations[0] : null;

  let displayLang = '';
  if (otherLanguage && otherLanguage.locale) {
    displayLang = otherLanguage.locale.toLowerCase();
  }

  const ariaLabel = displayAriaLabelLanguages(otherLanguage);
  const displayedLanguage = displayLanguages(otherLanguage);
  const linkToOtherLanguage = handleLanguageSelection(siteURL, otherLanguage);

  const searchContentFilter = useMemo(() =>
    ['news', 'event'].map((el) => `type:"${el}"`).join(' OR '), []);

  let addClickonKeyPress = () => {
    return null;
  };

  React.useEffect(() => {
    const getHits = async () => {
      const hitsPromises = [
        index.search(searchWord, {
          filters: 'type: "internalpage"', hitsPerPage: 7,
        }), index.search(searchWord, {
          filters: searchContentFilter, hitsPerPage: 14,
        }),
      ];
      const resolved = (await Promise.all(hitsPromises)).map((r) => r.hits);
      const hits = [...resolved[0], ...resolved[1]];
      const filtered = getFilteredAlgoliaResults(hits);
      setResults(filtered);
    };
    if (searchWord) {
      getHits();
    } else {
      setResults([]);
    }
  }, [searchWord, index, searchContentFilter]);

  const getButtonWidth = () =>
    document?.getElementById('jeSuisSmartphone')?.getBoundingClientRect()?.width;
  const {t} = useTranslation();

  React.useEffect(() => {
    let isSubscribed = true;
    if (typeof window !== 'undefined') {
      if (isSubscribed) {
        window?.addEventListener('resize', () => {
          if (displayButton) setButtonWidth(getButtonWidth());
        });
      }
    }

    const getUserNameAndRoles = async () => {
      const userInfo = await getUserInfoWithoutLogin();
      if (userInfo?.data) {
        if (userInfo.data.firstName || userInfo.data.lastName) {
          setUserName(
            userInfo.data.firstName?.charAt(0).toUpperCase()
            + userInfo.data.lastName?.charAt(0).toUpperCase()
          );
        }
      }
    };
    getUserNameAndRoles();

    return () => {
      isSubscribed = false;
      window.removeEventListener('resize', getButtonWidth);
    };
  }, [displayButton]);

  const login = async () => {
    await getUserInfo();
  };

  const logout = async () => {
    await userLogout();
    setUserName('');
  };
  const jeSuis = (
    <>
      <AppButton
        color="primary"
        id="jeSuisSmartphone"
        label={t('header.my.user.role')}
        minimize
        onClick={() => {
          setButtonWidth(getButtonWidth());
          setDisplayButton(!displayButton);
        }}
        padding={10}
        rightIcon={
          <IconContainer color="BLACK"
            icon="ARROW_DOWN_SMALL"
            size={10}
          />
        }
        tabIndex="0"
        variant="light"
        width={'100%'}
      >
        <p className={smartphoneStyles.userRoleTitle}>
          {t('header.my.user.role')}:{' '}
        </p>
        {' '}
        <span className={smartphoneStyles.userRole}>
          {role}
        </span>
      </AppButton>
      {displayButton && communityMenu && communityMenu.menu?.length > 0 && (
        <div className={smartphoneStyles.buttonList}>
          {communityMenu.menu[0]?.items?.map((item, index, arr) => {
            return (
              <>
                <button
                  aria-label="unknown item"
                  className={smartphoneStyles.containerCommunity}
                  key={index}
                  onClick={() => {
                    setRole(item.label);
                    setDisplayButton(false);
                  }}
                  onKeyPress={() => {
                    setRole(item.label);
                  }}
                >
                  <div className={smartphoneStyles.itemJeSuisLink}>
                    <span className={smartphoneStyles.jeSuisLink}>
                      {item.label}
                    </span>
                  </div>
                  <div className={smartphoneStyles.itemArrow}>
                    <IconContainer
                      color="BLACK"
                      icon="ARROW_RIGHT_LARGE"
                      size={20}
                    />
                  </div>
                </button>
                {index < arr.length - 1 && (
                  <div className={smartphoneStyles.roleSeparator}></div>
                )}
              </>
            );
          })}
        </div>
      )}
    </>
  );
  const AccesCompte = (
    <button
      className={smartphoneStyles.login}
      onClick={() => (userName ? logout() : login())}
      onKeyDown={() => (userName ? logout() : login())}
    >
      <div className={smartphoneStyles.userLoginIcon}>
        <IconContainer
          icon="ACCOUNT_RED"
          noHover
          size={20}
          variant="outlined"
        />
      </div>
      <span className={smartphoneStyles.userLogin}>
        {userName ? `${t('header.logout')}` : t('header.login')}
      </span>
    </button>
  );

  const Rechercher = (
    <div className={smartphoneStyles.rootContainerSearch}>
      <div className={smartphoneStyles.itemIconSearch}>
        <IconContainer
          color="BLACK"
          icon="SEARCH"
          size={30}
        />
      </div>
      <div className={smartphoneStyles.itemInputSearch}>
        <input
          aria-label="Rechercher"
          className={smartphoneStyles.search}
          onChange={(event) => {
            if (!openSearch) {
              setOpenSearch(true);
            }
            setSearchWord(event.target.value);
          }}
          placeholder={`${t('header.search')}`}
        />
      </div>
    </div>
  );

  if (typeof window !== 'undefined') {
    addClickonKeyPress = (event) => {
      event.preventDefault();
      const target = document.getElementById('hambMenu');
      if (event.key === 'Enter' || event.code === 'Space' || event.type === 'click') {
        target.click();
      }
    };
  }

  return (
    <>
      <input
        aria-label="Open menu"
        aria-labelledby={'labelButton'}
        className={smartphoneStyles.hambMenu}
        id="hambMenu"
        type="checkbox"
      />
      <header className={smartphoneStyles.smartphoneRoot}>
        <div className={smartphoneStyles.smartphoneRootChild}>
          <div className={smartphoneStyles.smartphoneRootChildGrid}>
            <div className={smartphoneStyles.smartphoneItemLogo}>
              <div className={smartphoneStyles.smartphoneLogo}>
                <div className={smartphoneStyles.smartphoneLogoContainer}>
                  <div className={smartphoneStyles.smartphoneLogoImageContainer}>
                    <Link
                      className={smartphoneStyles.logoSmall}
                      data-cy="logo-header-mobile"
                      to={logo?.navigationPath}
                    >
                      <Image
                        ariaLabel={t('header.logo')}
                        className={smartphoneStyles.logoSmall}
                        image={logo}
                      />
                    </Link>
                  </div>
                </div>
                {name !== '_ACCUEIL_SCIENCES_PO_' && (
                  <div className={smartphoneStyles.subtitleContainer}>
                    <h4 className={smartphoneStyles.subtitle}>{name}</h4>
                  </div>)}
              </div>
              {logoPartner && (
                <div className={smartphoneStyles.smartphoneLogoPartnerContainer}>
                  <div className={smartphoneStyles.smartphoneLogoPartnerItem}>
                    <a
                      aria-label={t('headr.logos.partner.arialabel', {
                        website: 'logoPartner?.linkTo'
                      })}
                      href={logoPartner?.linkTo}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Image
                        ariaLabel={t('header.logo.partner')}
                        image={logoPartner}
                      />
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={smartphoneStyles.hambMenuWrapper}>
            <label className={smartphoneStyles.hamb}
              htmlFor={'buttonFor'}
              id="labelButton"
            >
              <button
                aria-label={openMenu ?
                  t('header.menu.close') : t('header.menu.open')}
                id={'buttonFor'}
                onClick={(event) => {
                  addClickonKeyPress(event);
                  setOpenSearch(false);
                  setOpenMenu(!openMenu);
                  setSearchWord('');
                  setDisplayButton(false);
                }}
                onKeyDown={(event) => {
                  addClickonKeyPress(event);
                  setOpenSearch(false);
                  setOpenMenu(!openMenu);
                  setSearchWord('');
                  setDisplayButton(false);
                }}
                title={'menu'}
              >
                <IconContainer
                  classname={smartphoneStyles.smartphone}
                  color={'BLACK'}
                  icon={openMenu ? 'MENU_CLOSE' : 'MENU_BURGER'}
                  notFocus
                  size={30}
                />
              </button>
            </label>
          </div>
        </div>
        {openMenu && (
          <>
            <div className={smartphoneStyles.jeSuisSubBar}>
              {Rechercher}
            </div>
            {ENABLE_JE_SUIS_MENU && (
              <>
                <div className={smartphoneStyles.separator}></div>
                <div className={smartphoneStyles.jeSuisSubBar}>
                  {jeSuis}
                </div>
              </>
            )}
            {ENABLE_ACCESS_COMPTE && (
              <>
                <div className={smartphoneStyles.separator}></div>
                <div className={smartphoneStyles.accesCompteSubBar}>
                  {AccesCompte}
                </div>
              </>
            )}
          </>
        )}
      </header>
      {openMenu && (!results || !results.length > 0) && (
        <>
          {openSearch &&
          <div className={popUpStyles.container}>
            <div>
              <div className={popUpStyles.titleContainer}>
                <Title className={popUpStyles.title}
                  label={t('search.title')}
                />
                <div
                  aria-label={t('search.window.open')}
                  onClick={() => setOpenSearch(false)}
                  onKeyPress={() => setOpenSearch(false)}
                  role="button"
                  tabIndex="0"
                >
                  <IconContainer color="BLACK"
                    icon="MENU_CLOSE"
                    size={20}
                  />
                </div>
              </div>
            </div>
            <div>{t('search.noResult')}</div>
          </div>
          }
          <nav aria-label={t('siteNav.label')}
            className={smartphoneStyles.hambMenuSlider}
          >
            <NavigationSmartphoneHtml
              color="RED"
              menu={menu}
              siteURL={siteURL}
            >
            </NavigationSmartphoneHtml>
          </nav>
          <nav aria-label={t('transversalNav.label')}
            className={smartphoneStyles.hambMenuSlider}
          >
            <NavigationSmartphoneHtml
              color="BLACK"
              menu={corporateMenu?.menu}
              siteURL={siteURL}
            >
            </NavigationSmartphoneHtml>
          </nav>
          {otherLanguage && (
            <div className={smartphoneStyles.language}>
              <a
                aria-label={ariaLabel}
                className={smartphoneStyles.langButton}
                data-cy={`smartphone-language-${displayLang}`}
                href={linkToOtherLanguage}
                lang={displayLang}

              >
                {displayedLanguage}
              </a>
            </div>
          )}
        </>
      )}
      {openMenu && openSearch && results && results.length > 0 && (
        <div className={popUpStyles.container}>
          <div>
            <div className={popUpStyles.titleContainer}>
              <Title className={popUpStyles.title}
                label={t('search.title')}
              />
              <div
                aria-label={t('search.window.open')}
                onClick={() => setOpenSearch(false)}
                onKeyPress={() => setOpenSearch(false)}
                role="button"
                tabIndex="0"
              >
                <IconContainer color="BLACK"
                  icon="MENU_CLOSE"
                  size={20}
                />
              </div>
            </div>
          </div>
          <AlgoliaResults
            language={locale}
            results={results}
            searchWord={searchWord}
            websiteRoot={siteURL}
          />
        </div>)}
    </>
  );
});

Menu.propTypes = {
  communityMenu: PropTypes.shape({
    menu: PropTypes.arrayOf(PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
      })),
    })),
  }),
  corporateMenu: PropTypes.shape({
    menu: PropTypes.any,
  }),
  locale: PropTypes.string.isRequired,
  localizations: PropTypes.arrayOf(PropTypes.shape({
    locale: PropTypes.string.isRequired,
  })),
  logo: PropTypes.shape({
    navigationPath: PropTypes.string,
    image: PropTypes.object,
  }),
  logoPartner: PropTypes.shape({
    linkTo: PropTypes.string,
    image: PropTypes.object,
  }),
  menu: PropTypes.array,
  name: PropTypes.string,
  siteURL: PropTypes.string.isRequired,
};

export default Menu;
